export default __webpack_public_path__ + "static/Sea-to-Sky-Hotel-Logo-d4c4f260ab0d6e5637ce82e7eb643bd9.svg";